<!--  -->
<template>
  <div class="agreement_c">
    <div class="main_title">神州邦邦平台交易评价规则</div>
    <div class="sub_title">第一章 概述</div>
    <div class="main_item">
      <p>
        第一条
        为促进平台用户基于真实的交易作出公正、客观、真实的评价，进而为其他用户在购买服务的决策过程中提供有效参考，同时为工程师在接单服务过程中提供雇主最真实的意见反馈提供参考，神州邦邦平台根据《神州邦邦平台服务协议》《神州邦邦平台交易规则》等相关规定，制定本规则。
      </p>
      <p>第二条 本规则适用于在神州邦邦平台完成交易的雇主与工程师。</p>
      <p>
        第三条
        神州邦邦平台交易评价是指用户基于订单完结而产生的交易评价，即交易双方在神州邦邦平台完成交易且有成交金额的情况下对交易相对方进行的真实评价。
      </p>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">第二章 评价细则</div>
    <div class="main_item">
      <p>第四条 评价入口开放</p>
      <p>
        在交易完结后，交易评价入口开放，雇主可对工程师进行评价，评价提交后即可发布。
      </p>
      <p>第五条 评价条件</p>
      <p>
        只有成功的交易，雇主才有评价权，交易是否成功以该订单是否有成交金额为判断依据；如果全额退款，该订单无法评价。
      </p>
      <p>第六条 评价内容与规则</p>
      <p>评价等级：分为好评、中评、差评三个等级，每次评价仅能选择一项；</p>
      <p>评价内容：评价必须填写文字内容；</p>
      <p>
        星级评分：星级评分从1星至5星，根据服务情况分别对按时上门、服务态度、服务规范、技术能力、服务质量五个维度进行评分；
      </p>
      <p>第七条 存在官方介入调解的评价规则</p>
      <ul class="content_wrap1">
        <li>
          <p>
            交易过程中，如果双方存在交易纠纷，任意一方发起调解申请，经由神州邦邦平台调解判断后，评价规则如下：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                若订单全额付款或部分付款给工程师，则评价入口开放，可以正常评价；
              </p>
            </li>
            <li>
              <p>若全额退款给雇主，则评价入口关闭。</p>
            </li>
          </ul>
        </li>
        <li>
          <p>恶意评价：</p>
          <ul class="content_wrap2">
            <li>
              <p>
                恶意评价定义：指雇主、同行竞争者等利益相关评价人，以给中评、差评的方式达到不正当目的的行为。
              </p>
            </li>
            <li>
              <p>评价内容中存在以下行为将判定为“恶意评价”：</p>
              <p>
                1、评价泄露他人信息：擅自将他人的私人信息公布在评价内容或解释中的行为。
              </p>
              <p>
                2、评价中含有辱骂内容：在评价内容或解释中出现辱骂或污言秽语，损坏社会文明风貌等的行为。
              </p>
              <p>
                3、同行竞争者交易后给予负面评价：
                经查实为同行竞争者通过小号发起交易，评价内容恶意中伤（包括但不限于出现人身攻击性言论、与交易本身无关的言论）工程师，有明显不正当竞争嫌疑的行为。
              </p>
              <p>
                4、利用中差评威胁谋取不正当利益：评价者以中差评要胁为前提，对工程师提出不合理要求，谋取不正当的利益的行为。
              </p>
              <p>5、其他涉及不正当、不合理言论的评价内容。</p>
            </li>
            <li>
              <p>恶意评价的举报</p>
              <p>
                1、举报流程：打开神州邦邦App>个人中心＞联系客服或拨打客服热线400-676-3988，反馈恶意评价相关信息进行举报。
              </p>
              <p>
                2、判定结果：
                举报成立后，神州邦邦平台将屏蔽恶意评价的所有信息，并且该条评价不计入好评率和综合评分计算。神州邦邦平台有权对评价人名下所有账号处以限制操作7天，扣除500元保证金的处理。
              </p>
              <p>
                3、举报时效：被评价方须在被评价后30天内进行举报；未在规定时间内举报的，视为放弃举报权，神州邦邦平台有权不予受理。
              </p>
            </li>
          </ul>
        </li>
      </ul>
      <p>第八条 评价的审核</p>
      <ul class="content_wrap1">
        <li>
          <p>
            为了确保评价体系的公正性、客观性和真实性，神州邦邦平台将对违规交易评价、恶意评价、不当评价、异常评价等破坏神州邦邦平台信用评价体系、侵犯用户知情权的行为予以坚决打击，并保留通过法律途径维权的权利。
          </p>
        </li>
        <li>
          <p>
            神州邦邦平台有权对即将发布的评价内容进行审核，有权删除或屏蔽评价内容中所包含的污言秽语、广告信息、色情低俗内容及其他有违公序良俗的信息。
          </p>
        </li>
        <li>
          <p>
            神州邦邦平台有权对排查到的异常评价作出不计分、屏蔽、删除等处理。
          </p>
        </li>
        <li>
          <p>
            针对前述违规评价行为，除做相应处理外，神州邦邦平台将视不同情形对评价人采取身份验证、屏蔽评论内容、删除评价、限制评价、限制用户行为等处理措施。
          </p>
        </li>
      </ul>
      <p>第九条 好评率、综合评分计算规则</p>
      <ul class="content_wrap1">
        <li>
          <p>好评率计算规则</p>
          <p>好评率=所有收到的主动好评个数/所有收到的主动评价总数</p>
        </li>
        <li>
          <p>综合评分计算规则</p>
          <p>
            综合评分=所有收到的主动评分(按时上门+服务态度+服务范围+技术能力+服务质量的总分数和）/所有主动参与评分的人数/5
          </p>
        </li>
      </ul>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">第三章 附则</div>
    <div class="main_item">
      <p>第十条 生效时间</p>
      <p>本规则自发布之日起生效。</p>
      <p>第十一条 规则适用</p>
      <p>
        神州邦邦平台雇主、工程师的评价行为发生在本规则修订生效以前的，适用当时的规则；评价行为发生在本规则修订生效以后的，适用本规则。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.sub_title {
  font-size: 0.3rem;
  text-align: center;
  font-weight: 900;
  padding: 0 0 0.4rem;
}
</style>